export const LEVELS = {
    INFO: 'info',
    SUCCESS: "success",
    WARNING: 'warning',
    ERROR: 'error'
}